// removed by extract-text-webpack-plugin
module.exports = {"visible-xs":"visible-xs___1Dpl5","visible-sm":"visible-sm___2jtoa","visible-md":"visible-md___1a9M3","visible-lg":"visible-lg___EViIe","row":"row___1b0kP","hidden-xs":"hidden-xs___1HOst","hidden-sm":"hidden-sm___3hD86","hidden-md":"hidden-md___3J2ze","hidden-lg":"hidden-lg___2HX_V","page":"page___2zccX page___2ZhHk","title":"title___215zW h1___3_4RF line-bottom___2vxnm padding-bottom-3___3j9QG","answer-title":"answer-title___fICWr h2___hzLuT","answer-info":"answer-info___2RXMK h5___l1yk7"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Legal/Legal.css
// module id = 872
// module chunks = 0